"use client";

// components/public/GuideComparisonCta.tsx
// The one interactive piece of GuideComparisonTable: a /go/ hop with the same
// link contract as MidArticleCta's "hop" (AFFILIATE_REL, target=_blank, cta_click
// beacon). Split out so the table itself stays a server component.

import GoPrefetchAnchor from "@/components/public/GoPrefetchAnchor";
import { AFFILIATE_REL } from "@/lib/affiliate-rel";
import { trackCtaClick } from "@/lib/tracking/client-track";

interface GuideComparisonCtaProps {
  href: string;
  label: string;
  productSlug: string;
}

export default function GuideComparisonCta({ href, label, productSlug }: GuideComparisonCtaProps) {
  return (
    <GoPrefetchAnchor
      href={href}
      target="_blank"
      rel={AFFILIATE_REL}
      hrefLang="en"
      onClick={() => trackCtaClick({ linkUrl: href, ctaPlacement: "guide-comparison-table", productSlug })}
      className="inline-flex items-center text-base font-semibold text-forge-trust underline underline-offset-2 transition-colors hover:text-forge-trust-hover"
    >
      {label}
    </GoPrefetchAnchor>
  );
}
